"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledConfig = require("styled-config");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  float: left;\n  min-width: 10rem;\n  padding: ", ";\n  margin: ", ";\n  font-size: ", ";\n  color: ", ";\n  text-align: left;\n  list-style: none;\n  background-color: ", ";\n  background-clip: padding-box;\n  border: ", " ", ";\n  ", "\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      display: block;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      display: none;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var dropdownMenuHidden = function dropdownMenuHidden(props) {
  return props.hidden ? (0, _styledComponents.css)(_templateObject()) : (0, _styledComponents.css)(_templateObject2());
};

var borderRadius = function borderRadius(props) {
  if (props.noRadius) {
    return (0, _styledComponents.css)(_templateObject3(), (0, _styledConfig.borderRadius)(props, 'dropdownMenu').noRadius);
  }

  return (0, _styledComponents.css)(_templateObject4(), (0, _styledConfig.borderRadius)(props, 'dropdownMenu').default);
};

var DropdownMenu = _styledComponents.default.div(_templateObject5(), function (props) {
  return (0, _styledConfig.padding)(props, 'dropdownMenu').default;
}, function (props) {
  return (0, _styledConfig.margin)(props, 'dropdownMenu').default;
}, function (props) {
  return (0, _styledConfig.fontSize)(props, 'dropdownMenu').default;
}, function (props) {
  return (0, _styledConfig.colors)(props, 'dropdownMenu').color;
}, function (props) {
  return (0, _styledConfig.colors)(props, 'dropdownMenu').backgroundColor;
}, function (props) {
  return (0, _styledConfig.border)(props, 'dropdownMenu').default;
}, function (props) {
  return (0, _styledConfig.colors)(props, 'dropdownMenu').borderColor;
}, function (props) {
  return borderRadius(props);
}, function (props) {
  return dropdownMenuHidden(props);
});

exports.DropdownMenu = DropdownMenu;
DropdownMenu.defaultProps = {
  theme: _styledConfig.theme
};